<template>
  <div id="app">
    <navigation />
    <div class="main-container">
      <center-container>
        <router-view />
      </center-container>
    </div>
    <netzlab-footer></netzlab-footer>
  </div>
</template>
<style>
  .tr-red {
    background-color: #f8d7da;
  }

  .tr-green {
    background-color: #d4edda;
  }
</style>

<script>
  import Navigation from "components/navigation";
  import { USER_REQUEST } from "actions/user";
  import NetzlabFooter from "./components/footer/index.vue";
  import AzureHelper from "./helper/AzureHelper.js";
  import axios from "axios";
  import 'bootstrap';
  import 'bootstrap/dist/css/bootstrap.min.css'

  export default {
    title: 'Netzlab Stundenschreibung',
    components: {
      NetzlabFooter,
      Navigation
    },
    name: "app",
    async created () {
      if (this.$store.getters.isAuthenticated) {
        //Retrieve token and write into axios headers upon startup
        var token = localStorage.getItem("user-token");
        axios.defaults.headers.common['Authorization'] = "Bearer " + token;

        //Gather user data on startup
        this.$store.dispatch(USER_REQUEST);
      }

    //   const {
    //     VUE_APP_ORGANIZATION_NAME,
    //     VUE_APP_ORGANIZATION_URI,
    //     VUE_APP_AZURE_PERSONAL_ACCESS_TOKEN
    //   } = process.env

    //   const azure = new AzureHelper(VUE_APP_ORGANIZATION_NAME, VUE_APP_ORGANIZATION_URI, VUE_APP_AZURE_PERSONAL_ACCESS_TOKEN);
    //   const projects = await azure.getProjects()
    //   console.log(projects);
    //   azure.getQueryByWiql("Weinsphere.de");
    //   azure.getQueryByWiql("gardify Shop");
      
    }
  };
</script>

<style>
  body {
    margin: 0;
    font-family: "Roboto", sans-serif;
    color: #2e426b;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
</style>

<style scoped>
.main-container {
  min-height: calc(100vh - 70px);
}

/* For small screens and up */
@media (min-width: 576px) {
  .main-container {
    padding: 15px;
  }
}

/* For medium screens and up */
@media (min-width: 768px) {
  .main-container {
    padding: 30px;
  }
}

/* For large screens and up */
@media (min-width: 992px) {
  .main-container {
    padding: 60px;
    min-width: 992px;
  }
}
</style>
